export default "__VITE_ASSET__DtUTdE$w__"